module.exports = {"hello":"Hello!","language":"Language"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = 635
// module chunks = 1